import { useGetClusterInfoLazyQuery, useGetListSnapshotsLazyQuery, useGetStatsLazyQuery, } from "../../generated/graphql-types";
export const useGetStatsQuery = () => {
    const [getStats, { data, error, loading }] = useGetStatsLazyQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        getStats,
        error,
        loading,
        data: data?.Admin_getStats,
    };
};
export const useGetClusterInfoQuery = () => {
    const [getClusterInfo, { data, error, loading },] = useGetClusterInfoLazyQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        getClusterInfo,
        error,
        loading,
        data: data?.Admin_getClusterInfo,
    };
};
export const useGetListSnapshotsQuery = () => {
    const [getListSnapshots, { data, error, loading },] = useGetListSnapshotsLazyQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        getListSnapshots,
        error,
        loading,
        data: data?.Admin_getListSnapshots,
    };
};
//# sourceMappingURL=cluster-detail-service.js.map